import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { saveVisaPrepForm } from '../../../../../store/student/actions';
import { createUpdateVPIFieldAction } from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { InputWithConfirm, RadioOptionsWithConfirm, IQuestion } from 'shared-components';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const VisaPrepFormUniEnrolmentPage3 = (_props: any) => {
    const { t } = useTranslation('common');
  // dispatch actions
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(saveVisaPrepForm(Pages.PAGE7_3));
  };

  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(createUpdateVPIFieldAction(fieldName, value, refValue));
  const navigate = useNavigate();
  const onBackToTaskList = () => navigate(-1);

  // state props from store
  const visaPrepForm = useSelector(({ student }: ApplicationState) => student.visa, shallowEqual);
  const { appliedThroughUCAS, ucasPin } = visaPrepForm;

  // constants
  const currentStep = 3;
  const steps = 3;

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      appliedThroughUCAS,
      ucasPin,
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, appliedThroughUCAS, ucasPin]);

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={onNext}
      onBackToTaskList={onBackToTaskList}
      section={'University Enrolment'}
    >
      <RadioOptionsWithConfirm
        key={VQ.APPLIED_THROUGH_UCAS}
        id={VQ.APPLIED_THROUGH_UCAS}
        label={t('common:didYouApplyForYourCourseThroughU')}
        onClick={(question: IQuestion) => onChange(VQ.APPLIED_THROUGH_UCAS, question.label === 'Yes')}
        isInline={true}
        questions={[
          {
            char: 'Y',
            label: 'Yes',
            selected: appliedThroughUCAS === true,
          },
          {
            char: 'N',
            label: 'No',
            selected: appliedThroughUCAS === false,
          },
        ]}
      />
      {appliedThroughUCAS === true ? (
        <InputWithConfirm
          key={VQ.UCAS_PIN}
          id={VQ.UCAS_PIN}
          value={ucasPin}
          label={t('common:whatIsYourUcasPersonalIdentifica')}
          onChange={(evt: any) => {
            onChange(VQ.UCAS_PIN, evt.currentTarget.value);
          }}
        />
      ) : null}
    </QuestionPage>
  );
};
export default VisaPrepFormUniEnrolmentPage3;
